/* Lionheart — site interactions */
(function () {
  "use strict";
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Mark the current page in the nav */
  const page = document.body.dataset.page;
  if (page) $$(`[data-nav~="${page}"]`).forEach((a) => a.setAttribute("aria-current", "page"));

  /* Header shadow on scroll */
  const header = $(".site-header");
  const onScroll = () => header && header.classList.toggle("is-scrolled", window.scrollY > 8);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* Mobile menu */
  const toggle = $(".menu-toggle");
  if (toggle) {
    toggle.addEventListener("click", () => {
      const open = document.body.classList.toggle("menu-open");
      toggle.setAttribute("aria-expanded", String(open));
    });
    $$(".nav__item.has-dropdown > .nav__link").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (window.innerWidth > 980) return;
        e.preventDefault();
        const item = btn.parentElement;
        const open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", String(open));
      });
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && document.body.classList.contains("menu-open")) {
        document.body.classList.remove("menu-open");
        toggle.setAttribute("aria-expanded", "false");
        toggle.focus();
      }
    });
  }

  /* Hero slider */
  const hero = $(".hero");
  if (hero) {
    const slides = $$(".hero__slide", hero);
    const dots = $$(".hero__dot", hero);
    const DURATION = 7000;
    hero.style.setProperty("--slide-ms", DURATION + "ms");
    let idx = 0, timer;
    const go = (n) => {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s, i) => {
        s.classList.toggle("is-active", i === idx);
        s.setAttribute("aria-hidden", String(i !== idx));
      });
      dots.forEach((d, i) => {
        d.classList.remove("is-active");
        void d.offsetWidth; // restart progress animation
        d.classList.toggle("is-active", i === idx);
        d.setAttribute("aria-current", i === idx ? "true" : "false");
      });
      restart();
    };
    const restart = () => {
      clearTimeout(timer);
      if (!reduceMotion && !hero.classList.contains("is-paused")) timer = setTimeout(() => go(idx + 1), DURATION);
    };
    dots.forEach((d, i) => d.addEventListener("click", () => go(i)));
    $(".hero__arrow--prev", hero)?.addEventListener("click", () => go(idx - 1));
    $(".hero__arrow--next", hero)?.addEventListener("click", () => go(idx + 1));
    hero.addEventListener("mouseenter", () => { hero.classList.add("is-paused"); clearTimeout(timer); });
    hero.addEventListener("mouseleave", () => { hero.classList.remove("is-paused"); go(idx); });
    hero.addEventListener("focusin", () => { hero.classList.add("is-paused"); clearTimeout(timer); });
    let x0 = null;
    hero.addEventListener("touchstart", (e) => (x0 = e.touches[0].clientX), { passive: true });
    hero.addEventListener("touchend", (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    go(0);
  }

  /* Reveal on scroll + number counters */
  const animateCount = (el) => {
    const target = parseFloat(el.dataset.count);
    const decimals = (el.dataset.count.split(".")[1] || "").length;
    const prefix = el.dataset.prefix || "", suffix = el.dataset.suffix || "";
    const fmt = (v) => prefix + v.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
    if (reduceMotion) { el.textContent = fmt(target); return; }
    const t0 = performance.now(), dur = 1600;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add("is-visible");
        $$("[data-count]", en.target).forEach(animateCount);
        if (en.target.matches("[data-count]")) animateCount(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    $$(".reveal, .reveal-stagger, .stats").forEach((el) => io.observe(el));
  } else {
    $$(".reveal, .reveal-stagger").forEach((el) => el.classList.add("is-visible"));
  }

  /* Click-to-load YouTube (keeps pages fast and avoids third-party cookies until played) */
  /* Exposed so news feeds can wire up videos they render later */
  const initVideos = (root = document) => {
    $$("[data-youtube]:not([data-ready])", root).forEach((wrap) => {
      wrap.dataset.ready = "";
      const btn = $(".video-play", wrap);
      btn && btn.addEventListener("click", () => {
        const id = wrap.dataset.youtube;
        const iframe = document.createElement("iframe");
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        iframe.title = wrap.dataset.title || "Video";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        wrap.innerHTML = "";
        wrap.appendChild(iframe);
      });
    });
    /* Click-to-play self-hosted video */
    $$("[data-video]:not([data-ready])", root).forEach((wrap) => {
      wrap.dataset.ready = "";
      const btn = $(".video-play", wrap), video = $("video", wrap);
      btn && video && btn.addEventListener("click", () => {
        btn.remove();
        video.controls = true;
        video.play();
      });
    });
  };
  window.lionheartInitVideos = initVideos;
  initVideos();

  /* Tabs */
  $$("[data-tabs]").forEach((tabs) => {
    const btns = $$('[role="tab"]', tabs);
    const select = (btn) => {
      btns.forEach((b) => {
        const on = b === btn;
        b.setAttribute("aria-selected", String(on));
        b.tabIndex = on ? 0 : -1;
        $("#" + b.getAttribute("aria-controls")).hidden = !on;
      });
    };
    btns.forEach((b, i) => {
      b.addEventListener("click", () => select(b));
      b.addEventListener("keydown", (e) => {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        const next = btns[(i + (e.key === "ArrowRight" ? 1 : -1) + btns.length) % btns.length];
        next.focus(); select(next);
      });
    });
  });

  /* Forms.
     Set data-endpoint on a form (e.g. a Formspree/Shopify/HubSpot URL) to POST submissions.
     Without an endpoint, the contact form falls back to opening the visitor's email client. */
  const CONTACT_EMAIL = "mail@lionheartfarms.com.ph";
  $$("form[data-form]").forEach((form) => {
    const note = $(".form-note", form);
    const say = (msg, ok) => { if (note) { note.textContent = msg; note.classList.toggle("is-success", !!ok); } };
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const data = new FormData(form);
      const endpoint = form.dataset.endpoint;
      if (endpoint) {
        try {
          const res = await fetch(endpoint, { method: "POST", body: data, headers: { Accept: "application/json" } });
          if (!res.ok) throw new Error(res.statusText);
          form.reset();
          say(form.dataset.success || "Thank you! We'll be in touch soon.", true);
        } catch (err) {
          say("Sorry, something went wrong. Please email us at " + CONTACT_EMAIL + ".");
        }
        return;
      }
      if (form.dataset.form === "newsletter") {
        const subject = encodeURIComponent("News from the farm sign-up");
        const body = encodeURIComponent("Please add me to Lionheart's news from the farm: " + data.get("email"));
        window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
        say("Opening your email app to confirm your sign-up…", true);
        return;
      }
      const lines = [];
      data.forEach((v, k) => { if (k !== "subject" && v) lines.push(`${k[0].toUpperCase() + k.slice(1)}: ${v}`); });
      const subject = encodeURIComponent(data.get("subject") || "Website enquiry");
      window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${encodeURIComponent(lines.join("\n"))}`;
      say("Opening your email app with your message…", true);
    });
  });

  /* Prefill enquiry topic from ?topic= */
  const topic = new URLSearchParams(location.search).get("topic");
  const topicSelect = $("#enquiry-subject");
  if (topic && topicSelect) {
    const opt = $$("option", topicSelect).find((o) => o.value.toLowerCase().includes(topic.toLowerCase()));
    if (opt) topicSelect.value = opt.value;
  }

  /* Footer year */
  $$("[data-year]").forEach((el) => (el.textContent = new Date().getFullYear()));
})();
